import React from "react";
import MarkdownView from "@/components/MarkDownView";
import { FileAttachmentList } from "./FileAttachment";

export const Message = ({ message, onImageClick, isStreaming = false }) => {
  const isUser = message.role === "user";
  const messageText = message.parts?.[0]?.text || "";

  if (!messageText && !message.files?.length) return null;

  return (
    <div
      className={`flex ${
        isUser ? "justify-end" : "justify-start"
      } w-full min-w-0`}
    >
      <div
        className={`p-4 pb-0 rounded-2xl overflow-x-hidden min-w-0 ${
          isUser
            ? "user-message max-w-[80%] bg-slate-100 dark:bg-[#303030] dark:text-neutral-50"
            : "w-full"
        }`}
      >
        {message.files?.length > 0 && (
          <FileAttachmentList
            files={message.files}
            onImageClick={onImageClick}
            isUserMessage={isUser}
          />
        )}

        {messageText && (
          <MarkdownView isStreaming={isStreaming && !isUser}>
            {messageText}
          </MarkdownView>
        )}
      </div>
    </div>
  );
};
